package com.checkin.host.ui.components

import androidx.compose.runtime.Composable
import com.checkin.host.theme.AppColors
import com.checkin.host.theme.inputStyle
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.ref
import org.jetbrains.compose.web.attributes.value
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement

@Composable
fun FormLabel(text: String) {
    Label(attrs = {
        style {
            display(DisplayStyle.Block)
            fontSize(12.px)
            color(AppColors.muted)
            marginBottom(4.px)
        }
    }) {
        Text(text)
    }
}

@Composable
fun TextField(
    label: String,
    value: String,
    type: InputType<String> = InputType.Text,
    readOnly: Boolean = false,
    onValueChange: (String) -> Unit = {},
) {
    FormLabel(label)
    Input(type, attrs = {
        style {
            inputStyle()
            if (readOnly) {
                backgroundColor(AppColors.bg)
                color(AppColors.muted)
                cursor("default")
            }
        }
        value(value)
        if (readOnly) {
            attr("readonly", "readonly")
        } else {
            ref { element ->
                element.oninput = { event ->
                    onValueChange((event.target as HTMLInputElement).value)
                }
                onDispose {
                    element.oninput = null
                }
            }
        }
    })
}
